import './mines-playing-panel.scss';

import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@/app/store/hooks';
import { minesActions, selectMinesGame, selectMinesLoading } from '@/entities/mines';
import { type CurrencyCode, formatCurrencyValue } from '@/shared/lib/currency';
import { CashOutButton } from '@/shared/ui/CashOutButton';

export function MinesPlayingPanel() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const game = useAppSelector(selectMinesGame);
  const loading = useAppSelector(selectMinesLoading);

  if (!game) return null;

  const currency = (game.currency as CurrencyCode) ?? 'TON';

  return (
    <>
      <div className="mines-playing__info-row">
        <div className="mines-playing__stat">
          <span className="mines-playing__stat-label">{t('mines.bet')}</span>
          <span className="mines-playing__stat-value">
            {formatCurrencyValue(game.betAmount, currency)}
          </span>
        </div>
        <div className="mines-playing__stat">
          <span className="mines-playing__stat-label">{t('mines.minesLabel')}</span>
          <span className="mines-playing__stat-value">{game.minesCount}</span>
        </div>
        <div className="mines-playing__stat">
          <span className="mines-playing__stat-label">{t('mines.multiplier')}</span>
          <span className="mines-playing__stat-value mines-playing__stat-value--mult">
            {game.currentMultiplier.toFixed(4)}×
          </span>
        </div>
      </div>

      {game.revealedPositions.length > 0 && (
        <CashOutButton
          onClick={() => dispatch(minesActions.cashout())}
          disabled={loading}
          label={
            loading
              ? t('mines.cashingOut')
              : t('mines.cashOut', {
                  amount: formatCurrencyValue(game.betAmount * game.currentMultiplier, currency),
                })
          }
        />
      )}

      {game.nextMultiplier && (
        <p className="mines-playing__next">
          {t('mines.next')} <strong>{game.nextMultiplier.toFixed(4)}×</strong>
        </p>
      )}
    </>
  );
}
